module.exports = __webpack_public_path__ + "img/emoji-car-red-240x240.289ed223.png";